import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconShieldCheckSvg } from "./IconShieldCheckSvg.mjs";
const IconShieldCheck = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconShieldCheckSvg, ...iconProps });
};
export {
  IconShieldCheck
};
